export function SidebarItem({
	icon,
	label,
	active = false,
	variant = 'default',
	onClick,
	extraContent
}) {
	const baseClasses =
		'flex items-center gap-4 h-10 px-3 rounded-lg w-full transition-all duration-200';
	const activeClasses = active ? 'bg-[#f8f2fc]' : 'opacity-50 hover:opacity-100';

	let colorClass = '';
	if (variant === 'danger') {
		colorClass = active ? 'text-[#E90B0F]' : 'text-[#E90B0F] opacity-80';
	} else {
		colorClass = active ? 'text-purple' : 'text-dark-blue';
	}

	return (
		<button className={`${baseClasses} ${activeClasses}`} onClick={onClick}>
			<div className={`w-4 h-4 flex items-center justify-center ${colorClass}`}>{icon}</div>
			<span className={`text-base font-medium ${active ? 'font-semibold' : ''} ${colorClass}`}>
				{label}
			</span>
			{extraContent && <div className="ml-auto">{extraContent}</div>}
		</button>
	);
}
